/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { useTranslation } from 'react-i18next'
import useBreadcrumb from '../../NavBar/useBreadcrumb'
import { useEffect } from 'react'
import { Filters } from './Filters'
import { List } from './List'
import { ExportButton } from './ExportButton'
import { useQuery } from '@tanstack/react-query'
import useUser from '../../Shared/UserProvider/useUser'
import { useSearchParams } from 'react-router-dom-v5-compat'
import { Summary } from './summary'
import { getUnavailableItems } from '../../../services/Item/Item.service'

const DEFAULT_PAGE_SIZE = '50'

const UnavailableItems = () => {
    const [t] = useTranslation()
    const {setPaths} = useBreadcrumb()
    const {user} = useUser()
    const [searchParams, setSearchParams] = useSearchParams()

    const from = searchParams.get('from')
    const to = searchParams.get('to')
    const sortBy = searchParams.get('sortBy')
    const direction = searchParams.get('direction')
    const page = searchParams.get('page') || '1'
    const size = searchParams.get('size') || DEFAULT_PAGE_SIZE

    useEffect(() => {
        setPaths([{
            text: t('breadcrumb.home'),
            link: true,
            path: '/',
        }, {
            text: t('unavailable_items.header'),
            link: false,
        }])
    }, [])

    useEffect(() => {
        const next = new URLSearchParams(searchParams.toString())
        if (!searchParams.get('page') || !searchParams.get('size')) {
            next.set('page', '1')
            next.set('size', DEFAULT_PAGE_SIZE)
            setSearchParams(next, { replace: true })
        }
    }, [page, searchParams, setSearchParams, size])

    const {data} = useQuery({
        queryFn: () => getUnavailableItems(from, to, page, size, sortBy, direction),
        queryKey: ['pointofsales', user.getUserPos()?.id, 'unavailableItems', from, to, page, size, sortBy, direction],
        enabled: !!from && !!to,
        keepPreviousData: true,
    })

    const unavailableItems = data?.items

    return (
      <div>
          <h1>{t('unavailable_items.header')}</h1>

          <p>{t('unavailable_items.description')}</p>

          <div css={css`
              display: flex;
              align-items: center;
              
              & > a {
                  margin-top: .7rem;
              }
          `}>
              <Filters />

              <ExportButton unavailableItems={unavailableItems} />
          </div>

          <Summary />

          <List unavailableItems={unavailableItems} pagination={data?.pagination} />
      </div>
    )
}

export { UnavailableItems }
